import React from "react";
import $ from "jquery";
import FormMissingPoint from "../components/AccountPointReport";
import { getItemLocation } from "../apis/middlewareEndpoints";
import moment from "moment";
import { submitMissingPoint } from "../apis/member";

class MissingPoint extends React.Component {
  state = {
    hotel: "",
    loadings: [],
    check_in_date: "",
    check_out_date: "",
    confirmLoading: false,
    rewardLocationItemData: [],
    submited: false,
  };

  async componentDidMount() {
    const itemLocationData = await getItemLocation("issuance");
    this.setState({
      rewardLocationItemData: itemLocationData.data,
    });
  }

  showLoading() {
    this.setState(({ loadings }) => {
      const newLoadings = [...loadings];
      newLoadings[0] = true;

      return {
        loadings: newLoadings,
      };
    });
  }

  hideLoading() {
    this.setState(({ loadings }) => {
      const newLoadings = [...loadings];
      newLoadings[0] = false;

      return {
        loadings: newLoadings,
      };
    });
  }

  handleSubmit(params) {
    try {
      let self = this;
      self.showLoading();
      $(".action_status").text("");
      self.setState({ submited: false });
      let hotelData = params.reward_location.split("-");
      let check_in_date = moment(params.check_in_date, "YYYY-MM-DD");
      let check_out_date = moment(params.check_out_date, "YYYY-MM-DD");
      const bodyFormData = new FormData();
      bodyFormData.append("reward_location_id", hotelData[0]);
      bodyFormData.append("reward_location_name", hotelData[1]);
      bodyFormData.append("confirmation_no", params.confirmation_no);
      bodyFormData.append("check_in_date", check_in_date.format("YYYY-MM-DD"));
      bodyFormData.append(
        "check_out_date",
        check_out_date.format("YYYY-MM-DD")
      );
      bodyFormData.append("guest_name", params.guest_name);
      bodyFormData.append("inquiry_type_id", 2);
      bodyFormData.append("guest_id", this.props.guestId);

      if (params.message) {
        const withoutLineBreaks = params.message.replace(/[\r\n]/gm, " ");
        bodyFormData.append("message", withoutLineBreaks);
      }

      if (params.file_url) {
        if (params.file_url.file.status !== undefined) {
          if (params.file_url.file.status == "done") {
            if (params.file_url.file.originFileObj) {
              // Sanitize the file name: replace spaces and remove unsafe characters
              const file = params.file_url.file.originFileObj;
              const sanitizedFileName = file.name
                .replace(/\s+/g, "_") // Replace spaces with underscores
                .replace(/[^a-zA-Z0-9._-]/g, ""); // Remove unsafe characters

              // Create a new file object with the sanitized name
              const sanitizedFile = new File([file], sanitizedFileName, { type: file.type });
              // Append the sanitized file to the FormData
              bodyFormData.append("file", sanitizedFile);

            }
          }
        }
      }

      const successText = this.props.langData.submit_success;
      const errorText = this.props.langData.submit_error;

      (async () => {
        await submitMissingPoint(bodyFormData)
          .then(function (response) {
            self.hideLoading();
            if (response.status === 200) {
              self.setState({ submited: true });
              $(".ant-upload-list-item-card-actions-btn").trigger("click");
              $(".action_status").addClass("status_success").text(successText);
              self.setState({ submited: false });
            } else {
              $(".action_status").addClass("status_error").text(errorText);
            }
          })
          .catch(function (error) {
            if (error.response) {
              self.hideLoading();
            } else if (error.request) {
              self.hideLoading();
            } else {
              self.hideLoading();
            }
          });
        $(window).scrollTop(0);
      })();
    } catch (error) {
      this.hideLoading();
    }
  }

  render() {
    return (
      <FormMissingPoint
        stateProp={this.state}
        props={this.props}
        handleSubmit={(e) => this.handleSubmit(e)}
      />
    );
  }
}

export default MissingPoint;
